module.exports = __webpack_public_path__ + "media/images/flowbite_user-settings-solid (1)-c9878dfb3fc0c35208c9dc229a533ab3.png";